// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nul li[data-v-3c6d984e] {\n  list-style: none;\n  font-size: 13px;\n  color: #909399;\n}\n.spacing[data-v-3c6d984e] {\n  padding-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
